export const GET_ASSETS_CATEGORY_LIST = "GET_ASSETS_CATEGORY_LIST";
export const ASSETS_CATEGORY_API_START = "ASSETS_CATEGORY_API_START";
export const GET_SELECTED_ASSETS_CATEGORY_LIST =
  "GET_SELECTED_ASSETS_CATEGORY_LIST";
export const ADD_SUB_CAT = "ADD_SUB_CAT";
export const SUB_CAT_LIST = "SUB_CAT_LIST";
export const SUB_CAT_EDIT = "SUB_CAT_EDIT";
export const MAIN_CATEGORY_EDIT = "MAIN_CATEGORY_EDIT";
export const SUB_CATEGORY_EDIT = "SUB_CATEGORY_EDIT";
